import type { Tab } from "types/tabs.types"
import type { Tower } from "types/towers.types"

import { hasTowerSegments, isTowerHealthEnabled } from "helpers/utils/towerHealth"

import { ALL_ALERTS_SEARCH_PARAMS } from "./constants"

export const getTowerTabsConfig = (search: string, tower?: Tower): Tab[] => {
  const isHealthEnabled = Boolean(tower && isTowerHealthEnabled(tower))
  const hasSegments = Boolean(tower && hasTowerSegments(tower))

  const tabs: Omit<Tab, "value">[] = isHealthEnabled
    ? [
        { labelKey: "tabs.GLOBAL", to: { pathname: "", search } },
        ...(hasSegments
          ? [{ labelKey: "tabs.SEGMENTS", to: { pathname: "segments", search } }]
          : []),
        { labelKey: "tabs.DEVICES", to: { pathname: "devices", search } },
        { labelKey: "tabs.AMBIENT", to: { pathname: "ambient", search } },
      ]
    : [
        { labelKey: "tabs.OVERVIEW", to: { pathname: "", search } },
        { labelKey: "tabs.DEVICES", to: { pathname: "devices", search } },
      ]

  // Alerts and Settings are only relevant for tower-health-enabled towers
  // (Settings currently holds only the notice that alert settings moved to Alerts).
  const alertsTabs: Omit<Tab, "value">[] = isHealthEnabled
    ? [
        {
          labelKey: "tabs.ALERTS",
          to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
        },
        { labelKey: "tabs.SETTINGS", to: { pathname: "settings" } },
      ]
    : []

  return [...tabs, ...alertsTabs].map((tab, index) => ({ ...tab, value: index }))
}
